import Chart from "react-apexcharts";
import { Loading } from "../../../componentes/loading/loading";
import { formatarDataComDiaSemana } from "../../../utils/formatDate";

export function ProducaoHeatmap({ report, loading, ranges, type }) {
  const data = report.totalPorDia || [];

  const labels = [...new Set(data.map(i => i.data))]
    .sort((a, b) => new Date(a) - new Date(b));

  const colaboradores = [...new Set(data.map(i => i.nome))];

  const series = colaboradores.map(nome => ({
    name: nome,
    data: labels.map(date => {
      const row = data.find(
        i => i.data === date && i.nome === nome
      );

      return {
        x: formatarDataComDiaSemana(date),
        y: row?.[type] || 0 // pode trocar por paletes
      };
    })
  }));

  const options = {
    chart: {
      type: "heatmap",
      toolbar: { show: true },
      animations: {
        enabled: false
      }
    },

    dataLabels: {
      enabled: true
    },

    plotOptions: {
      heatmap: {
        enableShades: false,
        distributed: false,
        radius: 4,
        colorScale: {
          ranges: ranges
        }
      }
    },

    xaxis: {
      type: "category",
      labels: {
        rotate: -45,
        style: { fontSize: "10px" }
      }
    },

    legend: {
      position: "top"
    }
  };

  return (
    <div style={{ width: "100%" }}>
      {!loading ? (
        <Chart
          options={options}
          series={series}
          type="heatmap"
          height={350}
        />
      ) : (
        <Loading />
      )}
    </div>
  );
}